import { render, staticRenderFns } from "./EventNavigation.vue?vue&type=template&id=bc83d030&scoped=true&"
import script from "./EventNavigation.vue?vue&type=script&lang=js&"
export * from "./EventNavigation.vue?vue&type=script&lang=js&"
import style0 from "./EventNavigation.vue?vue&type=style&index=0&id=bc83d030&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bc83d030",
  null
  
)

export default component.exports